import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Form, Field, reduxForm } from "redux-form";
import { RejectReason, RejectOther } from "../../common/input";
import { required } from "../../../util/validate";
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";

const ViewStationsModal = ({ closeAction, stations }) => {
  //Show reject model
  return (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal reject">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closeAction}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "70vh", overflow: "auto", fontWeight:"normal" }}
            >
              <div className="editNonFct-header modal-header">
                <ul>
                  {stations.map((e) => {
                    return <li>{e}</li>;
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default reduxForm({ form: "reason" })(ViewStationsModal);



// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/ViewStationsModal.js